import { parseDef } from "../parseDef.js";

//#region src/utils/zod-to-json-schema/parsers/readonly.ts
const parseReadonlyDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};

//#endregion
export { parseReadonlyDef };
//# sourceMappingURL=readonly.js.map